// Enqueues a background job (BullMQ) that scans Comtrade availability for the
// requested year range. Returns 202 + jobId — the actual scan can take a
// while (throttled external API calls per HS version x year), so it's queued
// instead of blocking the request. Poll/listen via getCountryOverviewJobStatus.
//
// `force: true` bypasses the once-a-day Comtrade cache on the backend (used
// by the "Check Comtrade update" button); omit it (or false) for normal page
// loads / Apply, which reuse today's cached result where available.
export function enqueueCountryOverview(
  axiosPrivate: any,
  params: {year_from: number; year_to: number; force?: boolean}
) {
  return axiosPrivate.post('/trade-data-management-v2/country-overview', params)
}

export function getCountryOverviewJobStatus(axiosPrivate: any, jobId: string | number) {
  return axiosPrivate.get(`/trade-data-management-v2/country-overview-job-status/${jobId}`)
}
